// Real-time price and date updates on the main auction listing page (cards with price and date).
// When an offer is made, the card updates instantly via ActionCable (no batch delay).
import consumer from "./consumer"

var MAX_IDS_PER_REFRESH = 60
var LISTING_REFRESH_DELAY_MS = 1500

// Parse displayed/formatted price (e.g. "230,00 €" or "2 500,00") to number for comparison.
function parsePriceToNumber(str) {
  if (str == null || typeof str !== "string") return NaN
  var cleaned = str.replace(/\s/g, "").replace(",", ".").replace(/[^\d.-]/g, "")
  return parseFloat(cleaned) || NaN
}

function updateListingTabCounts() {
  var specs = [
    { containerId: "pills-online-auction",      tabSel: "#pills-online-auction-tab .tab-count" },
    { containerId: "pills-auction-announcement", tabSel: "#pills-auction-announcement-tab .tab-count" },
    { containerId: "pills-notice-sale",          tabSel: "#pills-notice-sale-tab .tab-count" }
  ]
  var total = 0
  specs.forEach(function (s) {
    var container = document.getElementById(s.containerId)
    if (!container) return
    var count = container.querySelectorAll("[data-auction-id]").length
    total += count
    var tabEl = document.querySelector(s.tabSel)
    if (tabEl) tabEl.textContent = "(" + count + ")"
  })
  var totalEl = document.querySelector(".item-total span.fw-sbold")
  if (totalEl) totalEl.textContent = String(total)
}

function removeAuctionCard(auctionId) {
  const idStr = String(auctionId)
  const container = document.getElementById("pills-online-auction")
  let cards = container ? container.querySelectorAll("[data-auction-id=\"" + idStr + "\"]") : []
  if (!cards.length) cards = document.querySelectorAll("[data-auction-id=\"" + idStr + "\"]")
  var removed = false
  cards.forEach(function (card) { card.remove(); removed = true })
  if (removed) updateListingTabCounts()
}

function removeExpiredCards() {
  var container = document.getElementById("pills-online-auction")
  if (!container) return
  var now = Math.floor(Date.now() / 1000)
  var removed = false
  container.querySelectorAll("[data-ends-at]").forEach(function (card) {
    var endsAt = parseInt(card.getAttribute("data-ends-at"), 10)
    if (endsAt > 0 && endsAt < now) {
      card.remove()
      removed = true
    }
  })
  if (removed) updateListingTabCounts()
}

function startEndedCardRemover() {
  if (window._endedCardRemoverStarted) return
  window._endedCardRemoverStarted = true
  removeExpiredCards()
  setInterval(removeExpiredCards, 60000)
}

function applyListingUpdate(auctionId, data) {
  if (data.ended) {
    removeAuctionCard(auctionId)
    return
  }
  if (data.highest_ad_bid == null && data.ad_publication_date == null) return
  const idStr = String(auctionId)
  const container = document.getElementById("pills-online-auction")
  let cards = container ? container.querySelectorAll("[data-auction-id=\"" + idStr + "\"]") : []
  if (!cards.length) cards = document.querySelectorAll("[data-auction-id=\"" + idStr + "\"]")
  cards.forEach(function (card) {
    if (data.highest_ad_bid != null && data.highest_ad_bid !== "") {
      const priceEl = card.querySelector(".item-price")
      if (priceEl) {
        var newPriceNum = parsePriceToNumber(data.highest_ad_bid)
        var currentPriceNum = parsePriceToNumber(priceEl.textContent)
        // Only update if new price is >= current (avoids stale listing_prices cache overwriting real-time value)
        if (isNaN(currentPriceNum) || newPriceNum >= currentPriceNum) {
          priceEl.textContent = data.highest_ad_bid + " €"
        }
      }
    }
    if (data.ad_publication_date != null && data.ad_publication_date !== "") {
      const timeEl = card.querySelector(".item-time-value")
      if (timeEl) {
        timeEl.textContent = data.ad_publication_date
      } else {
        const itemTime = card.querySelector(".item-time")
        if (itemTime) {
          const textNode = Array.from(itemTime.childNodes).find(function (n) {
            return n.nodeType === Node.TEXT_NODE && n.textContent.trim()
          })
          if (textNode) textNode.textContent = " " + data.ad_publication_date
          else itemTime.appendChild(document.createTextNode(" " + data.ad_publication_date))
        }
      }
    }
    if (data.ends_at != null) {
      card.setAttribute("data-ends-at", data.ends_at)
    }
  })
}

function subscribeToAuctionListing() {
  var _wasDisconnected = false
  var sub = consumer.subscriptions.create("AuctionListingChannel", {
    connected() {
      if (_wasDisconnected) {
        // Reconnected after a drop — fetch current prices to catch up on missed broadcasts.
        _wasDisconnected = false
        refreshListingPricesFromServer()
      }
    },
    disconnected() {
      _wasDisconnected = true
    },
    received(data) {
      try {
        if (data.auction_id == null || (data.highest_ad_bid == null && data.ad_publication_date == null)) return
        applyListingUpdate(data.auction_id, data)
        scheduleDelayedListingRefresh()
      } catch (e) {
        console.warn("[AuctionListingChannel] update error:", e)
      }
    }
  })
  return sub
}

var _listingRefreshTimeout = null

function refreshListingPricesFromServer() {
  const container = document.getElementById("pills-online-auction")
  if (!container) return
  const cards = container.querySelectorAll("[data-auction-id]")
  const ids = []
  for (var i = 0; i < cards.length && ids.length < MAX_IDS_PER_REFRESH; i++) {
    const id = cards[i].getAttribute("data-auction-id")
    if (id && ids.indexOf(id) === -1) ids.push(id)
  }
  if (ids.length === 0) return
  const url = "/listing_prices?ids=" + encodeURIComponent(ids.join(","))
  fetch(url, { credentials: "same-origin" })
    .then(function (res) { return res.ok ? res.json() : null })
    .then(function (payload) {
      if (!payload || typeof payload !== "object") return
      Object.keys(payload).forEach(function (id) {
        const entry = payload[id]
        if (entry && (entry.highest_ad_bid != null || entry.ad_publication_date != null)) {
          applyListingUpdate(id, entry)
        }
      })
    })
    .catch(function () {})
}

function scheduleDelayedListingRefresh() {
  if (_listingRefreshTimeout) clearTimeout(_listingRefreshTimeout)
  _listingRefreshTimeout = setTimeout(function () {
    _listingRefreshTimeout = null
    refreshListingPricesFromServer()
  }, LISTING_REFRESH_DELAY_MS)
}

function setupVisibilityRefresh() {
  if (window._auctionListingVisibilitySetup) return
  window._auctionListingVisibilitySetup = true
  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "visible" && document.body.getAttribute("data-realtime-listing-prices") !== "false") {
      // Re-create subscription if it was lost while tab was hidden.
      if (!window._auctionListingSubscription) {
        window._auctionListingSubscription = subscribeToAuctionListing()
      }
      refreshListingPricesFromServer()
    }
  })

  // Handle Firefox bfcache restores (persisted=true pageshow). Firefox freezes page state
  // including prices when navigating back; visibilitychange may not fire in that case.
  // Refreshing here ensures prices are current when the user returns via browser back button.
  window.addEventListener("pageshow", function (ev) {
    if (!ev.persisted) return
    if (document.body.getAttribute("data-realtime-listing-prices") === "false") return
    refreshListingPricesFromServer()
  })

  // Handle internet reconnection (e.g. mobile network switching, brief disconnects).
  // Debounced to avoid multiple resubscription cycles when online fires rapidly.
  var _listingOnlineDebounce = null
  window.addEventListener("online", function () {
    if (document.body.getAttribute("data-realtime-listing-prices") === "false") return
    if (_listingOnlineDebounce) clearTimeout(_listingOnlineDebounce)
    _listingOnlineDebounce = setTimeout(function () {
      _listingOnlineDebounce = null
      // Re-create subscription so ActionCable reconnects cleanly.
      if (window._auctionListingSubscription) {
        try { window._auctionListingSubscription.unsubscribe() } catch (e) {}
        window._auctionListingSubscription = null
      }
      window._auctionListingSubscription = subscribeToAuctionListing()
      refreshListingPricesFromServer()
    }, 300)
  })
}

function getListingPollIntervalMs() {
  const container = document.getElementById("pills-online-auction")
  if (!container) return 30000
  const count = container.querySelectorAll("[data-auction-id]").length
  if (count > 300) return 0
  if (count > 200) return 60000
  if (count > 50) return 30000
  return 10000
}

function startListingPollIfNeeded() {
  if (window._auctionListingPollStarted) return
  if (document.body.getAttribute("data-realtime-listing-prices") === "false") return
  window._auctionListingPollStarted = true
  function tick() {
    if (document.visibilityState !== "visible") return
    if (!document.getElementById("pills-online-auction")) return
    var next = getListingPollIntervalMs()
    if (next > 0) {
      refreshListingPricesFromServer()
      window._auctionListingPollTimer = setTimeout(tick, next)
    } else {
      window._auctionListingPollTimer = setTimeout(tick, 60000)
    }
  }
  window._auctionListingPollTimer = setTimeout(tick, getListingPollIntervalMs())
}

function initAuctionListingRealtime() {
  if (document.body.getAttribute("data-realtime-listing-prices") === "false") return
  if (window._auctionListingSubscription) return
  window._auctionListingSubscription = subscribeToAuctionListing()
}

var _lastInitRefresh = 0

function scheduleListingInit() {
  initAuctionListingRealtime()
  setupVisibilityRefresh()
  startListingPollIfNeeded()
  startEndedCardRemover()
  // Refresh prices immediately on every navigation to the listing page so bids placed
  // while the user was on the ad detail page are reflected without waiting for the poll.
  // Debounced 500ms to absorb DOMContentLoaded + turbolinks:load firing close together.
  var now = Date.now()
  if (document.getElementById("pills-online-auction") && now - _lastInitRefresh > 500) {
    _lastInitRefresh = now
    refreshListingPricesFromServer()
  }
  if (!window._auctionListingSubscription) {
    setTimeout(initAuctionListingRealtime, 400)
  }
  if (!window._auctionListingSubscription) {
    setTimeout(initAuctionListingRealtime, 800)
  }
}

document.addEventListener("DOMContentLoaded", scheduleListingInit)
if (typeof Turbolinks !== "undefined" && Turbolinks.Events) {
  document.addEventListener("turbolinks:load", scheduleListingInit)
}
if (document.readyState !== "loading") {
  setTimeout(scheduleListingInit, 0)
}
document.addEventListener("DOMContentLoaded", function () {
  const tab = document.getElementById("pills-online-auction-tab")
  if (tab) {
    tab.addEventListener("shown.bs.tab", function () {
      initAuctionListingRealtime()
    })
  }
})

export { subscribeToAuctionListing, initAuctionListingRealtime }
